import { render } from "./link-list.vue?vue&type=template&id=02e2be52"
import script from "./link-list.vue?vue&type=script&lang=js"
export * from "./link-list.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__